import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { NavLink, useLocation  } from "react-router-dom";

import MenuImage from "../images/menu-icon.png";
import yoLogo from "../images/yo_logo.png";
import { useUnreadCount } from "./UnreadCountContext";

type Props = {
  user: any;
};

const MenuBar: React.FC<Props> = (props) => {
  const location = useLocation();
  const headerRef = useRef<HTMLDivElement | null>(null);
  const [active, setActive] = useState<boolean>(true);
  // Use unread count from context
  const { notificationUnread } = useUnreadCount();

  console.log('MenuBar sees unreadCount:', notificationUnread);

  const menuToggle = async () => {
    setActive(!active);
  };

  useEffect(() => {
    if (window.innerWidth < 767) setActive(false);
  }, []);

  useLayoutEffect(() => {
    const setHeaderH = () => {
      const h = headerRef.current?.offsetHeight ?? 60;
      document.documentElement.style.setProperty("--header-height", `${h}px`);
    };
    setHeaderH();
    window.addEventListener("resize", setHeaderH);
    return () => window.removeEventListener("resize", setHeaderH);
  }, []);

  const isHomePage = location.pathname === '/' || location.pathname === '/home';

  return (
    <header ref={headerRef} className="header">
      <ul
        className={
          active
            ? "d-flex align-items-center white uppercase futuralt-book"
            : "d-flex align-items-center white uppercase futuralt-book hidden"
        }
      >
        <li><NavLink to="/home">Home</NavLink></li>

        <li style={{ position: "relative" }}>
          <NavLink to="/my-page">My Page</NavLink>
          {notificationUnread > 0 &&
            (notificationUnread > 9 ? (
              <span
                className="icon-badge homepage-menubar-badge--multi"
                style={{
                  position: "absolute",
                  // top: 2,
                  right: -30,
                  background: "red",
                  bottom: -7,
                  color: "white",
                  borderRadius: "50%",
                  padding: "3px 4.5px",
                  fontSize: 12,
                  fontWeight: "bold",
                  minWidth: 20,
                  textAlign: "center",
                  zIndex: 10,
                }}
              >
                9+
              </span>
            ) : (
              <span
                className="icon-badge homepage-menubar-badge--single"
                style={{
                  position: "absolute",
                  right: -27,
                  bottom: -6,
                  background: "red",
                  color: "white",
                  borderRadius: "50%",
                  padding: "0.4px 7px",
                  fontSize: 14,
                  fontWeight: "bold",
                  minWidth: 21,
                  textAlign: "center",
                  zIndex: 10,
                }}
              >
                {notificationUnread}
              </span>
            ))}
        </li>
        <li>
          <NavLink to="/faq">HOW IT WORKS</NavLink>
        </li>
        <li>
          <NavLink to="/search-restaurant">Restaurant Search</NavLink>
        </li>
        <li>
          <NavLink to="/about">About</NavLink>
        </li>
        {props.user.isLogged ? (
          <li>
            <NavLink to="/logout">Logout</NavLink>
          </li>
        ) : (
          <li>
            <NavLink to="/login">Login</NavLink>
          </li>
        )}
      </ul>
      <div className="menu-toggle" onClick={menuToggle}>
        <img src={MenuImage} alt="Toggle" />
      </div>
      {!isHomePage && (
        <NavLink to="/home" aria-label="Go to Home">
          <img src={yoLogo} alt="" aria-hidden="true" className="yo-badge-in-header"/>
        </NavLink>
      )}
    </header>
  );
};

export default MenuBar;
